import { render, staticRenderFns } from "./BaseAccountType.vue?vue&type=template&id=bf96222c&scoped=true"
import script from "./BaseAccountType.vue?vue&type=script&lang=js"
export * from "./BaseAccountType.vue?vue&type=script&lang=js"
import style0 from "./BaseAccountType.vue?vue&type=style&index=0&id=bf96222c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf96222c",
  null
  
)

export default component.exports